const AlertFooter = () => {
  return (
    <div className='flex h-6 w-full items-center justify-between bg-gray-11 px-4 text-white'>
      <div className='font-bold text-xs'>⚠️ Em desenvolvimento - visível somente para coblers </div>
      <div className='flex items-center gap-4 px-2 text-xs'>
        <a
          className='flex font-medium text-xs hover:text-white hover:underline'
          target='_blank'
          href='https://cobli.notion.site/17a682738c9c81c38a29c0d79d1b1e37?pvs=105'
          rel='noreferrer'
        >
          💡 Enviar sugestão de melhoria?
        </a>
        <a
          className='flex font-medium text-xs hover:text-white hover:underline'
          target='_blank'
          href='https://cobli.notion.site/17a682738c9c81fa88cfd103bb6a9c42?pvs=105'
          rel='noreferrer'
        >
          🐞 Reportar problema ou bug?
        </a>
      </div>
    </div>
  );
};

export default AlertFooter;
